import React, { FC } from 'react';
import styled from 'styled-components/native';

import dynamicSize from '@webtrader/core/dynamic-size';
import { useTheme } from '@webtrader/core/services/theme/v2';

import MaterialIcons from '@/components/Icons/Material';
import Text from '@/components/Text';

interface IProps {
  label?: string;
}

const ActionSheetSimpleSelector: FC<IProps> = (props) => {
  const { label } = props;

  const { theme } = useTheme();

  return (
    <SimpleSelectorField>
      <SimpleSelector>
        <SimpleSelectValueText>{label}</SimpleSelectValueText>
        <MaterialIcons name="arrow-drop-down" size={20} color={theme.colors.text[1]} />
      </SimpleSelector>
    </SimpleSelectorField>
  );
};

export default ActionSheetSimpleSelector;

const SimpleSelectorField = styled.View``;

const SimpleSelector = styled.View`
  align-items: center;
  flex-direction: row;
`;

const SimpleSelectValueText = styled(Text)`
  font-size: ${dynamicSize.convertSize(13)}px;
  font-weight: 500;
`;
